module.exports = __webpack_public_path__ + "static/media/bod03.a64d7d62.jpg";